<template>
    <div class="container-xxl">
        <h6><router-link :to="{name:'Info_create'}">最新公告</router-link>&ensp;>&ensp;公告明細&ensp;
            <b-icon v-show="obj.typ=='alert'" icon="bell-fill" variant="warning" font-scale="1.5" ></b-icon>
            <b-icon v-show="obj.typ=='mess'" icon="chat-quote-fill" variant="success" font-scale="1.5"></b-icon>
        </h6>
      <b-card :header="obj.title">
      <blockquote class="blockquote mb-0">
       <div style="text-align:left;font-size: 16px;">刊登日期 : {{fdateformat(obj.created_at)}} | 發文者 : {{obj.froms}}</div>
        <p></p>
        <div style="text-align:left;font-size: 16px;"><span v-html="obj.rmg" /></div>       
      </blockquote>
    </b-card>
    </div>
</template>
<script>
import { cmessService } from '../../_services/'
import * as moment from "moment/moment";

const queryData = params => {
  return cmessService.finditem(params.page) 
};

export default{
    name: 'Info_contorl_detail',     
    data(){
        return{
            uId:{String},
            obj:[],
        }
    },
  methods: {
    fetch(params = {}) {
      queryData({
        ...params,
      }).then(({ data }) => {
          this.obj = data;
      });
    },
    fdateformat(val){
        return moment(val).format("YYYY-MM-DD HH:mm"); 
    }
  },
    mounted(){
        //console.log(this.$route.query.userId);
        this.uId = this.$route.params.id
        this.fetch({page:this.uId});
    },
    

}
</script>